const SPACING_VALUES = {
  none: {
    default: 0,
    sm: 0,
    md: 0,
    xl: 0,
    xxl: 0,
  },
  small: {
    default: 6,
    sm: 6,
    md: 10,
    xl: 14,
    xxl: 14,
  },
  medium: {
    default: 8,
    sm: 10,
    md: 12,
    xl: 16,
    xxl: 16,
  },
  large: {
    default: 8,
    sm: 12,
    md: 16,
    xl: 20,
    xxl: 20,
  },
};

export { SPACING_VALUES };
